import { forwardRef, useImperativeHandle, useState } from 'react'
import { Form, Input, Modal, Spin } from 'antd'
import { updateAreaEncryptPassword, updateAreaEncryptStatus } from '../../common/request'
import ResponseCode from '../../common/response-code'

const UpdateAreaEncryptStatusModal = forwardRef((props, ref) => {
  const [formRef] = Form.useForm()
  const [modalVisible, setModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = () => {
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    formRef.resetFields()
  }

  const onOk = () => {
    formRef.validateFields().then(fields => {
      setLoading(true)
      updateAreaEncryptPassword({
        ...fields,
      }).then(res => {
        if (res.code === ResponseCode.success) {
          Modal.success({
            title: '操作成功',
            content: `更新区域安全密码成功`
          })
          hideModal()
        } else {
          Modal.error({
            title: '错误',
            content: res.msg,
            centered: true
          })
        }
      }).finally(() => {
        setLoading(false)
      })
    })
  }

  return (
    <Modal
      title="修改安全密码"
      open={ modalVisible }
      onOk={ onOk }
      onCancel={ hideModal }
      confirmLoading={ loading }
    >
      <Spin spinning={ loading }>
        <div className="my-4 px-4">
          <Form
            labelCol={ {
              span: 8
            } }
            wrapperCol={ {
              span: 14
            } }
            form={ formRef }>
            <Form.Item
              label="原密码" required name="oldPwd" rules={ [{
              required: true,
              message: '请输入原密码'
            }] }>
              <Input.Password placeholder="请输入原密码"></Input.Password>
            </Form.Item>
            <Form.Item
              label="新密码" required name="newPwd" rules={ [{
              required: true,
              message: '请输入新密码'
            }] }>
              <Input.Password placeholder="请输入新密码"></Input.Password>
            </Form.Item>
            <Form.Item
              label="再次输入新密码" required name="newPwdAgain" rules={ [{
              required: true,
              message: '请输入新密码'
            }] }>
              <Input.Password placeholder="请输入新密码"></Input.Password>
            </Form.Item>
          </Form>
        </div>
      </Spin>
    </Modal>
  )
})

export default UpdateAreaEncryptStatusModal
